const MAX_IMAGE_SIZE = 2 * 1024 * 1024;
const MAX_IMAGE_SIZE_MB = 2;

const loadImage = (file) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    const url = URL.createObjectURL(file);

    image.onload = () => {
      URL.revokeObjectURL(url);
      resolve(image);
    };

    image.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('Invalid image file'));
    };

    image.src = url;
  });

const canvasToBlob = (canvas, type, quality) =>
  new Promise((resolve) => canvas.toBlob(resolve, type, quality));

export const compressImageToMaxSize = async (file, maxSize = MAX_IMAGE_SIZE) => {
  if (!file || !file.type?.startsWith('image/') || file.size <= maxSize) {
    return file;
  }

  const image = await loadImage(file);
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  const outputType = 'image/jpeg';
  let scale = Math.min(1, Math.sqrt(maxSize / file.size));
  let quality = 0.85;
  let blob = null;

  for (let attempt = 0; attempt < 12; attempt += 1) {
    canvas.width = Math.max(1, Math.round(image.width * scale));
    canvas.height = Math.max(1, Math.round(image.height * scale));
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.drawImage(image, 0, 0, canvas.width, canvas.height);

    blob = await canvasToBlob(canvas, outputType, quality);
    if (blob && blob.size <= maxSize) {
      const name = file.name.replace(/\.[^.]+$/, '.jpg');
      return new File([blob], name, {
        type: outputType,
        lastModified: Date.now(),
      });
    }

    if (quality > 0.45) {
      quality -= 0.1;
    } else {
      scale *= 0.82;
    }
  }

  throw new Error(`Max file size is ${MAX_IMAGE_SIZE_MB}MB`);
};

export const MAX_IMAGE_SIZE_ERROR = `Max file size is ${MAX_IMAGE_SIZE_MB}MB`;
